PaysValidator.$inject = ['validator'];

export default function PaysValidator(validator) {
    const instance = new validator();
    return instance;
}
